import { render } from "./GaugeFormController.vue?vue&type=template&id=37d28dff"
import script from "./GaugeFormController.vue?vue&type=script&lang=js"
export * from "./GaugeFormController.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__